<dx-popup
  [(visible)]="showPopup"
  [width]="1000"
  [height]="'auto'"
  [maxHeight]="'80vh'"
  [showTitle]="true"
  [showCloseButton]="true"
  [dragEnabled]="false"
  [resizeEnabled]="false"
  position="center"
  [enableBodyScroll]="false"
  [hideOnOutsideClick]="false"
  (onHidden)="clearReceipt()"
>
  <div id="receipt_pdf" class="fs_18">
    <div class="d-flex w-100 justify-content-between align-items-center mb-5">
      <div>
        <img
          width="142px"
          height="35px"
          src="./assets/images/logo/shohay-updated-logo.svg"
        />
      </div>
      <div class="fs_24">
        <span>Payment Receipt: </span>
        <span class="c_0054a6">{{ receipt?.invoice_no }}</span>
      </div>
    </div>

    <div class="fs_24 fw-bold mb-3">Invoice to:</div>

    <div class="d-flex justify-content-between mb-2">
      <div class="fw-bold">Name: {{ receipt?.invoice_to }}</div>
      <div>Date: {{ receipt?.invoice_date | date : "MMM dd, yyyy" }}</div>
    </div>
    <div class="d-flex justify-content-between mb-5">
      <div>
        <span class="fw-bold">{{ receipt?.label2Name }} :</span>
        {{ receipt?.label2Value }}
      </div>
      <div class="fw-bold">
        Payment Method:
        <span class="c_0054a6">{{ receipt?.payment_method }}</span>
      </div>
    </div>

    @if(!receipt_file){
    <div class="fs_24 fw-bold c_0054a6 mb-2">{{ receipt?.paid_to }}</div>

    <div class="table_row bc_f2f9ff border-bottom-0">
      <div class="col-3">{{ receipt?.firstColumnName }}</div>
      <div class="col-7">{{ receipt?.secondColumnName }}</div>
      <div class="col-2 text-end">{{ receipt?.thirdColumnName }}</div>
    </div>
    <div class="table_row mb-3">
      <div class="col-3 text-dark fw-bold">
        {{ receipt?.firstColumnValue }}
      </div>
      <div class="col-7 text-dark fw-bold">
        <span
          *ngIf="getType(receipt?.secondColumnValue) === 'number'"
          class="text-dark fw-bolder"
          >৳
        </span>
        {{ receipt?.secondColumnValue }}
      </div>
      <div class="text-dark fw-bold col-2 text-end">
        <span class="text-dark fw-bolder">৳ </span>
        {{ receipt?.thirdColumnValue | number }}
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <div class="total">
        <div class="fs_18 fw-bolder">Total</div>
        <div class="fs_16 fw-bolder c_0054a6">
          <span class="fw-bolder">৳ </span>
          {{ +receipt?.total_amount | number }}
        </div>
      </div>
    </div>
    } @else { @if(receipt_file?.resource_type === 'pdf') {
    <div class="pdf_div">
      <pdf-viewer
        [src]="receipt_file?.url"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="zoomIndex"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        style="width: 100%; height: 400px"
      ></pdf-viewer>
      <div class="d-flex flex-column gap-3">
        <img
          title="Zoom-in"
          class="cursor"
          src="/assets/images/icon/zoom_in_icon.svg"
          (click)="zoom(0.1)"
        /><img
          title="Zoom-out"
          class="cursor"
          src="/assets/images/icon/zoom_out_icon.svg"
          (click)="zoom(-0.1)"
        /><img
          title="Download"
          class="cursor"
          src="/assets/images/icon/download_round_icon.svg"
          (click)="downloadFile(receipt_file?.url)"
        />
      </div>
    </div>
    } @else {
    <div class="popup_value">
      @if(receipt_file?.url) {
      <img class="w-100 my-3" [src]="receipt_file?.url" />} @else {Not
      Available!}
    </div>
    } }
  </div>

  <div class="d-flex justify-content-end mt-5">
    <button
      class="blue-button-md"
      (click)="receipt_file ? downloadFile(receipt_file?.url) : downloadPDF()"
    >
      Download
    </button>
  </div>
</dx-popup>
